export default __webpack_public_path__ + "static/media/wave-05.27d19a2c.png";